import { createStore } from '@aibees/shared/store';
import { JobTitleExpanderStoreData } from './types';

const useJobTitleExpanderStore = createStore<JobTitleExpanderStoreData>(
  'job-title-expander',
  (set) => ({
    // API data
    data: undefined,
    setData: (data) => set({ data }),
    clearData: () => set({ data: undefined }),

    // Selected values
    selectedValues: [],
    setSelectedValues: (selectedValues) => set({ selectedValues }),
    addSelectedValue: (value) =>
      set((state) => ({
        selectedValues: state.selectedValues.includes(value)
          ? state.selectedValues
          : [...state.selectedValues, value],
      })),
    removeSelectedValue: (value) =>
      set((state) => ({
        selectedValues: state.selectedValues.filter((v) => v !== value),
      })),
    clearSelectedValues: () => set({ selectedValues: [] }),

    // Suggestions
    suggestionsItem: undefined,
    setSuggestionsItem: (suggestionsItem) => set({ suggestionsItem }),
    clearSuggestionsItem: () => set({ suggestionsItem: undefined }),

    // Loading state
    isLoading: false,
    setIsLoading: (isLoading) => set({ isLoading }),

    // Combine entries
    combine: false,
    setCombine: (combine) => set({ combine }),

    // Search state
    searchQuery: '',
    setSearchQuery: (searchQuery) => set({ searchQuery }),
    clearSearchQuery: () => set({ searchQuery: '' }),

    // Dialog state
    isOpen: false,
    setIsOpen: (isOpen) => set({ isOpen }),
    toggleOpen: () => set((state) => ({ isOpen: !state.isOpen })),

    // Reset all state
    reset: () =>
      set({
        data: undefined,
        selectedValues: [],
        suggestionsItem: undefined,
        isLoading: false,
        combine: false,
        searchQuery: '',
        isOpen: false,
      }),
  })
);

export default useJobTitleExpanderStore;
